import type { KeyTextField } from '@prismicio/client';
import { memo } from 'react';

import styles from './animationListItem.module.scss';

interface AnimationListItemProps {
  heading: KeyTextField;
  description?: KeyTextField;
  index: number;
  activeItem: number;
  onClick: (itemNumber: number) => void;
  animationStart: boolean;
  variation: 'default' | 'engineLanding';
}

const AnimationListItemComponent = ({
  heading,
  description,
  index,
  activeItem,
  onClick,
  animationStart,
  variation,
}: AnimationListItemProps) => {
  const isActive = index === activeItem;

  const itemStyles = `${styles.item}  ${isActive && animationStart ? styles.isActive : ''} ${styles[variation]} ${styles[`item-${index}`]}`;
  const isVisibleStyles = `${styles.animation_container} ${animationStart ? styles.isVisible : ''}`;

  return (
    <li
      className={isVisibleStyles}
      onClick={() => onClick(index)}
      style={{ transitionDelay: `${0.1 + 0.1 * index}s` }}
    >
      <div className={itemStyles}>
        <div className={styles.number}>
          <span>{index + 1}</span>
        </div>
        <div className={styles.container}>
          <span className={styles.title}>{heading}</span>
          {description && (
            <span className={styles.description}>{description}</span>
          )}
        </div>
      </div>
    </li>
  );
};

export const AnimationListItem = memo(AnimationListItemComponent);
